import { FC } from "react";
import { useSearchModelView } from "./SearchModelView.hooks";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Loading } from "../Loading";
import { Model } from "@/atoms/model";

interface SearchModelViewProps {
  onClickSelector: (model: Model) => void;
}

export const SearchModelView: FC<SearchModelViewProps> = (props) => {
  const { onClickSelector } = props;
  const { t, onSubmit, form, models, errorMessage, loading } = useSearchModelView();

  return (
    <div className="flex h-full w-full flex-col gap-y-2">
      <span className="text-lg font-semibold">{t("search_model_title")}</span>
      {/* Form */}
      <form
        className="flex flex-col gap-y-4"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <div className="flex flex-col gap-y-2">
          <label className="text-sm">{t("search_model_code")}</label>
          <Input type="text" {...form.register("model.modelCode")} />
        </div>
        <div className="flex flex-col gap-y-2">
          <label className="text-sm">{t("search_model_name")}</label>
          <Input type="text" {...form.register("model.modelName")} />
        </div>
        <Button variant="default" type="submit">
          {t("search")}
        </Button>
      </form>

      {/* Loading */}
      {loading && <Loading />}
      {/* Error message */}
      {!loading && errorMessage && (
        <div>
          <span className="text-sm font-normal">{errorMessage}</span>
        </div>
      )}
      {/* Results */}
      {!loading && models.length > 0 && (
        <ScrollArea>
          <table className="w-full table-fixed">
            <thead>
              <tr className="border-b bg-[#F4F4F5]">
                <th className="w-1/4 p-1.5 text-left" />
                <th className="p-1.5 text-left">
                  <span className="text-sm font-bold text-zinc-500">{t("search_model_code")}</span>
                </th>
                <th className="p-1.5 text-left">
                  <span className="text-sm font-bold text-zinc-500">{t("search_model_name")}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Selector */}
              {models.map((model, index) => (
                <tr key={index} className="border-b p-1.5">
                  <td className="w-1/4 p-1.5 text-left">
                    <Button
                      onClick={() => onClickSelector(model)}
                      className="h-[28px] text-sm font-normal"
                      variant="secondary"
                    >
                      {t("selection")}
                    </Button>
                  </td>
                  <td className="break-words p-1.5 text-left">
                    <span className="text-sm font-normal">{model.code}</span>
                  </td>
                  <td className="break-words p-1.5 text-left">
                    <span className="text-sm font-normal">{model.name}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </ScrollArea>
      )}
    </div>
  );
};
